<!--
 * @Description: 谷仓-商机
 * @Author: mdb
 * @Date: 2022-06-30 20:51:19
 * @LastEditTime: 2023-04-10 16:26:53
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <a-tabs v-model:activeKey="queryForm.dataType" @change="handleTabsChange">
        <a-tab-pane key="all" :tab="t('common.all')" />
        <a-tab-pane key="me" :tab="t('business.e1svrf')" />
        <a-tab-pane key="subUser" :tab="t('business.97srub')" />
      </a-tabs>
      <cos-table
        serial
        :columns="columns"
        v-model:search="queryForm"
        @fetch="getList"
        @mask="showMask"
        ref="tableRef"
        rowKey="id"
        tableId="DcCosOFbuBusiness"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="status" :label="t('business.7xsihs')">
              <CosSelect
                v-model:value="queryForm.statusList"
                :options="businessStatusEnum"
                mode="multiple"
                :placeholder="t('common.pleaseSelect')"
                allowClear
              />
            </dc-form-item>
            <dc-form-item name="customerName" :label="t('business.7y5c89')">
              <a-input
                v-model:value.trim="queryForm.customerName"
                :maxlength="100"
                allowClear
                :placeholder="t('common.pleaseInput')"
              />
            </dc-form-item>
            <dc-form-item :label="t('business.nnrhea')">
              <a-input v-model:value="queryForm.arkCode" allowClear :placeholder="t('common.pleaseInput')" />
            </dc-form-item>
            <dc-form-item name="dutyByList" :label="t('business.l6hwus')" v-if="queryForm.dataType !== 'me'">
              <UserSelect v-model:value="queryForm.dutyByList" allowClear mode="multiple"/>
            </dc-form-item>
            <dc-form-item name="headDestinationCountryWarehouseList" :label="t('business.me6p1g')">
              <ParamCodesSelect
                v-model:value="queryForm.headDestinationCountryWarehouseList"
                mode="multiple"
                :options="paramCodeData.ofbu_demand_info"
                allowClear
              />
            </dc-form-item>
            <dc-form-item name="timeType" :label="t('business.uv0uo4')">
              <a-input-group compact>
                <!-- 时间查询类型：【0/1/2/3,创建时间/更新时间/首次入库时间/首次成交时间】-->
                <a-select v-model:value="queryForm.timeType" style="width: 33%">
                  <a-select-option :value="0">{{ t('business.wwys5u') }}</a-select-option>
                  <a-select-option :value="1">{{ t('business.dp8n8j') }}</a-select-option>
                  <a-select-option :value="2">{{ t('business.sj39ks') }}</a-select-option>
                  <a-select-option :value="3">{{ t('business.sasd32') }}</a-select-option>
                </a-select>
                <CosRangePicker
                  isOutputBeijingTime
                  v-model:startTime="queryForm.startTime"
                  v-model:endTime="queryForm.endTime"
                  style="width: 67%"
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item name="saleChanceRefId" :label="t('business.udlavq')">
              <a-input
                v-model:value.trim="queryForm.saleChanceRefId"
                :maxlength="100"
                allowClear
                :placeholder="t('common.pleaseInput')"
              />
            </dc-form-item>
            <dc-form-item name="id" :label="t('business.u21f2s')">
              <a-input
                v-model:value.trim="queryForm.id"
                :maxlength="100"
                allowClear
                :placeholder="t('common.pleaseInput')"
              />
            </dc-form-item>
          </a-form>
        </template>

        <template #button>
          <a-button v-permission="'ofbu_business_add_btn'" type="primary" @click="triggerAddOrEdit()">{{
            t('btn.add')
          }}</a-button>
          <ExportButton v-permission="'ofbu_business_export_btn'" appId="cos_ofbu" taskType="407" :search="queryForm">{{
            t('btn.export')
          }}</ExportButton>
        </template>

        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'saleChanceName'">
            <router-link :to="'/ofbu/business/view?id=' + record.id">
              <template v-if="record.arkCode">
                <template v-if="record.headDestinationCountryWarehouse">
                  <p>{{ `${record.arkCode}+${getDemandInfoName(record.headDestinationCountryWarehouse)}` }}</p>
                </template>
                <template v-else><p>{{ record.arkCode }}</p></template>
              </template>
              <template v-else>
                <template v-if="record.headDestinationCountryWarehouse">
                  <p>{{ getDemandInfoName(record.headDestinationCountryWarehouse) }}</p>
                </template>
                <template v-else>--</template>
              </template>
            </router-link>
          </template>
          <template v-if="column.dataIndex === 'customerName'">
            <router-link
              :to="getCustomLink(record)"
              class="ant-table-cell-ellipsis"
              :title="text"
            >{{ text || '--' }}</router-link>
          </template>
          <template v-if="column.dataIndex === 'status'">
            <dc-status :enums="statusEnum" :value="text" />
          </template>
          <template v-if="column.dataIndex === '$currency'">
            <p>{{ `${record.planSaleAmount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${text}` }}</p>
          </template>
          <template v-if="column.dataIndex === '$avgMonthlySalesCurrency'">
            <p>
              {{
                record.avgMonthlySales
                  ? `${record.avgMonthlySales?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${text}`
                  : '--'
              }}
            </p>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <a-button
              v-permission="'ofbu_business_write_follow_btn'"
              type="link"
              @click="handleWriteFollowUp(record.saleChanceRefId, record.id)"
              >{{ t('btn.writeFollow') }}</a-button
            >
            <SellerButton
              v-permission="'ofbu_business_edit_btn'"
              type="link"
              @click="triggerAddOrEdit(record.id)"
              >{{ t('btn.edit') }}</SellerButton
            >
            <a-button v-permission="'ofbu_business_del_btn'" type="link" @click="handleDelete(record)">{{
              t('btn.del')
            }}</a-button>
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { reactive, computed, ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import { listByParamCodes } from '@/api/common'
import { businessStatusEnum, orderTypeEnum } from '@/views/overseasSales/commonEnum/dataConfig'
import type { ParamCodeItem } from '@/typings/common'
import { businessList, businessDelete, businessDetails } from '@/api/overseasSales/chanceManage'
import { BusinessParams, BusinessListItem } from '@/typings/api/chanceManage'
import { useInteractionStore } from '@/stores/interaction'
import { useI18n } from 'vue-i18n'
const router = useRouter()
const route = useRoute()
const { t } = useI18n()

// 商机状态枚举
const statusEnum = computed(() => {
  const list = businessStatusEnum.map((item) => ({
    name: t(item.lang),
    value: item.value,
    color: item.color
  }))
  return list
})
const paramCodeData = ref<{
  ofbu_chance_type: ParamCodeItem[]
  ofbu_head_competitors: ParamCodeItem[]
  ofbu_warehouse: ParamCodeItem[]
  ofbu_head_domestic_warehouse: ParamCodeItem[]
  ofbu_demand_info: ParamCodeItem[]
  ofbu_head_replenish_method: ParamCodeItem[]
  ofbu_currency: ParamCodeItem[]
  ofbu_shipments: ParamCodeItem[]
}>({
  ofbu_chance_type: [], // 商机类型
  ofbu_head_competitors: [], // 头程竞争对手
  ofbu_warehouse: [], // 尾程竞争对手（目前合作海外仓）
  ofbu_head_domestic_warehouse: [], // 国内仓库
  ofbu_demand_info: [], // 区域仓(需求海外仓参数)
  ofbu_head_replenish_method: [], // 运输方式
  ofbu_currency: [], // 币种
  ofbu_shipments: [] // 发货量
})
const shareInfo = useInteractionStore()
const eumns = {
  'en-US': 'enName',
  'zh-CN': 'cnName'
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: [
      'ofbu_chance_type',
      'ofbu_head_competitors',
      'ofbu_warehouse',
      'ofbu_head_domestic_warehouse',
      'ofbu_demand_info',
      'ofbu_head_replenish_method',
      'ofbu_currency',
      'ofbu_shipments'
    ]
  }).then((res) => {
    paramCodeData.value = res.data
  })
}
onMounted(() => getByParamCodes())
const tableRef = ref()
const queryForm = reactive<BusinessParams>({ dataType: 'all', timeType: 0 })
const columns = computed(() => [
  { title: t('business.pehfv5'), dataIndex: 'saleChanceName', fixed: 'left', width: 190 },
  { title: t('business.7y5c89'), dataIndex: 'customerName', width: 200 },
  { title: t('business.udlavq'), dataIndex: 'saleChanceRefId' },
  { title: t('business.nnrhea'), dataIndex: 'arkCode' },
  { title: t('business.u21f2s'), dataIndex: 'id' },
  { title: t('business.ptwqaa'), dataIndex: 'customerNumber' },
  { title: t('business.kolh0f'), dataIndex: 'currency', dicData: paramCodeData.value.ofbu_currency },
  { title: t('business.t3fsg4'), dataIndex: 'shipments', dicData: paramCodeData.value.ofbu_shipments },
  { title: t('business.me6p1g'), dataIndex: 'headDestinationCountryWarehouse', dicData: paramCodeData.value.ofbu_demand_info },
  { title: t('business.7xsihs'), dataIndex: 'status' },
  { title: t('business.tw4fv1'), dataIndex: 'avgMonthlySalesCurrency', dicData: paramCodeData.value.ofbu_currency },
  { title: t('business.ts2f2s'), dataIndex: 'avgMonthlyOrder' },
  { title: t('business.sj39ks'), dataIndex: 'firstInboundDate' },
  { title: t('business.sasd32'), dataIndex: 'firstTransactionDate' },
  { title: t('business.l6hwus'), dataIndex: 'dutyByName' },
  { title: t('common.remark'), dataIndex: 'remark' },
  { title: t('common.createByName'), dataIndex: 'createByName' },
  { title: t('common.createTime'), dataIndex: 'createTime', width: 190 },
  { title: t('business.dp8n8j'), dataIndex: 'updateTime', width: 190 },
  {
    title: t('common.action'),
    dataIndex: 'action',
    langWidth: {
      zh: 180,
      en: 220
    },
    fixed: 'right'
  }
])
const getCustomLink = (row:any) => {
  if (row && row.stage === 2) {
    return `/ofbu/potential/view?cosId=${row.saleChanceRefId}`
  }
  if (row && row.stage === 3) {
    return `/ofbu/contract/view?cosId=${row.saleChanceRefId}`
  }
  if (row && row.stage === 4) {
    return `/ofbu/clients/view?cosId=${row.saleChanceRefId}`
  }
  return ''
}
const getList = (queryForm: BusinessParams, callBack: (res: any) => void) => {
  businessList(queryForm).then((res) => {
    callBack(res)
  })
}
const showMask = (record: BusinessListItem, callBack: (res: any) => void) => {
  businessDetails({ id: record.id }).then((res) => {
    callBack(res.data)
  })
}
/// 用来匹配商机名字的区域仓名
const getDemandInfoName = (headDestinationId?: number) => {
  const find = paramCodeData.value.ofbu_demand_info?.find((item) => item.id === headDestinationId)
  if (find) {
    return find[eumns[shareInfo.language]] ?? find.name
  }
  return headDestinationId || ''
}
const handleTabsChange = (val: any) => {
  queryForm.dataType = val
  if (val === 'me' && queryForm.dutyByList) {
    queryForm.dutyByList = undefined
  }
  tableRef.value?.search()
}
// 新增编辑函数
const triggerAddOrEdit = (id?: number) => {
  if (id) {
    router.push({ path: '/ofbu/business/edit', query: { id } })
  } else {
    router.push('/ofbu/business/add')
  }
}
const handleDelete = (row: BusinessListItem) => {
  Modal.delete({
    name: row.saleChanceNameByTxt,
    onOk() {
      businessDelete({ id: row.id }).then(() => {
        message.success(t('business.bp7zke'))
        tableRef.value?.delFetch()
      })
    }
  })
}
// 跳转写跟进页面
const handleWriteFollowUp = (cosId: string, chanceId: string) => {
  router.push({
    path: '/ofbu/followUpRecord/add',
    query: { followRefId: cosId, chanceId, returnPath: route.fullPath }
  })
}
/**
 * 竞争对手序列化
 * @param orderType 订单类型
 * @param arr 对手数组
 */
const competitorFormat = (orderType: number, arr: any) => {
  if (!Array.isArray(arr) || !arr?.length) return '--'
  const hasOrderType = orderTypeEnum.find((e) => e.value === orderType)
  if (!hasOrderType) return arr
  const listEnum = orderType === 1 ? paramCodeData.value.ofbu_head_competitors : paramCodeData.value.ofbu_warehouse
  const result: string[] = []
  arr.forEach((ele) => {
    const item = listEnum.find((e) => e.id === ele)
    if (item) result.push(item[eumns[shareInfo.language]] || (item.name as string))
  })
  return result.join('、')
}
</script>
<script lang="ts">
export default { name: 'DcCosOFbuBusiness' }
</script>

<style lang="scss" scoped></style>
